;(function () {
  'use strict'

  angular.module('deskfy.core').directive('coreTableColumnRowGroups', tableColumnRowGroups)

  /* @ngInject */
  function tableColumnRowGroups (Utils) {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        id: '<'
      },
      templateUrl:
        '/core/directives/table-columns/table-column-row-groups/table-column-row-groups-directive.html?$$REVISION$$',
      link: function ($scope) {
        $scope.tooltipGroups = ''
        $scope.showTooltip = false
        activate()

        function activate () {
          if ($scope.value.length > 1) {
            $scope.value.forEach(group => {
              const groupName = Utils.truncateText(group.name, 70)
              const newArray = $scope.tooltipGroups.concat(groupName, '<br>')
              $scope.tooltipGroups = newArray
            })
            $scope.showTooltip = true
            $scope.groupName = `${Utils.truncateText($scope.value[0].name, 10)} +${$scope.value.length - 1}`
          } else {
            $scope.groupName = $scope.value[0].name ? Utils.truncateText($scope.value[0].name, 10) : ''

            if ($scope?.value[0]?.name && $scope?.value[0]?.name.length > 10) {
              $scope.showTooltip = true
              $scope.tooltipGroups = $scope.value[0].name
            }
          }
        }
      }
    }
  }
})()
